/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Type_NewInputs */

const vi_tea_type_new = /** @type {(inputs: Tea_Type_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm loại chè`)
};

/**

* @param {Tea_Type_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_type_new = /** @type {((inputs?: Tea_Type_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Type_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_type_new(inputs)
});